import { Button } from '~/components/button';
import { DialogSection } from '~/components/dialogs/dialog-section.component';
import { StyledModal as Dialog } from '~/components/dialogs/dialog.style';
import { Utility as UtilityDropdown } from '~/components/dropdowns';
import { Form } from '~/components/form';
import { Inputs } from '~/components/inputs';
import { Container } from '~/components/layout';
import { useForm } from '~/hooks';
import { store } from '~/utils/store';
import { ErrorMessage } from '../error-message';

export const SelectUtilityDialog = ({
  error,
  onClose,
  onSubmit,
  pending,
}: SelectUtilityDialogProps) => {
  const [form, updateForm, isValid] = useForm({
    utilityId: 0,
    zipCode: '',
  });

  return (
    <Dialog
      isOpen
      aria-label="Select utility dialog"
      dangerouslyBypassFocusLock={store.get('DEV_TOOLS')}
    >
      <Dialog.Header title="Check availability" onClose={onClose} />
      <DialogSection>
        With just two pieces of information, we can see if you can join a solar farm today or if
        Community Solar is on the horizon for your state.
      </DialogSection>
      <DialogSection>
        <Form isValid={isValid} onSubmit={() => onSubmit(form as UtilityForm)}>
          <Container addInputMargin>
            <Inputs.ZipCode onChange={updateForm} value={form.zipCode} />
            <UtilityDropdown onChange={updateForm} value={form.utilityId} zipCode={form.zipCode} />
          </Container>
          <ErrorMessage error={error} />
          <Button mode="primary" disabled={!isValid} loading={pending} mt={3} type="submit">
            Continue
          </Button>
        </Form>
      </DialogSection>
    </Dialog>
  );
};

export interface SelectUtilityDialogProps {
  error?: string;
  onClose: () => void;
  onSubmit: (data: UtilityForm) => void;
  pending: boolean;
}

type UtilityForm = { utilityId: number; zipCode: string };
